<template>
    <Button type="submit" :color="color" :large="large" :loading="loading" :disabled="disabled" icon="check" @click="$emit('click')"><slot></slot></button>
</template>

<script>
    import Button from '../Button'

    export default {
        props: {
            color: {
                type: String,
                default: 'primary'
            },
            large: Boolean,
            loading: Boolean,
            disabled: Boolean
        },
        components: {
            Button
        }
    }
</script>